import { render, staticRenderFns } from "./page-royaumes.vue?vue&type=template&id=37a7bbfa&scoped=true&"
import script from "./page-royaumes.vue?vue&type=script&lang=js&"
export * from "./page-royaumes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a7bbfa",
  null
  
)

export default component.exports